export default {
  title: 'Find noget, du elsker!',
  description: 'Dine ordrer vises her.',
  buttons: {
    order_now: 'Bestil nu',
  },
};
